import moment from "moment";
import PanelTypes from "../panels/PanelTypes";

export const getFormattedTime = (dateToFormat, suffix = "") => `${moment(dateToFormat).format("HH:mm")}${suffix}`;

export const getFormattedDayAndTime = (day, dateToFormat, suffix = "") => {
    return `${day}, ${moment(dateToFormat).format("HH:mm")}${suffix}`;
};

export const getFormattedNamesFromArray = (idsArray, data, field) => {
    return idsArray.reduce((accumulator, id) => {
        if (accumulator === "") {
            accumulator = data[id][field];
        } else {
            accumulator = `${accumulator}, ${data[id][field]}`;
        }
        return accumulator;
    }, "");
};

export const zeroPad = number => {
    if (number < 10 && number >= 0) {
        return `0${number}`;
    }
    return `${number}`;
};

export const getForumFullAgenda = appData => {
    return appData.forumSchedule.reduce((acc, day) => {
        day.agenda.map(item => acc.push(item));
        return acc;
    }, []);
};

export const getActualPanel = forumFullAgenda => {
    return forumFullAgenda.reduce(
        (acc, item) => {
            if (moment().isBetween(item.startTime, item.endTime)) {
                if (item.itemType === PanelTypes.PANEL) {
                    acc = { panels: [...acc.panels, ...item.panels] };
                }
            }
            return acc;
        },
        { panels: [] }
    );
};

export const checkIfIOS = () => {
    let userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent);

    if (ios) {
        return true;
    }
    return false;
};

export const registerScreens = {
    PURCHASER: 0,
    ATTENDERS: 1,
    REGISTRATION_FEE: 2,
    VERIFICATION: 3,
    ACCREDITATION_START: 4,
    QR_CODE: 5,
    SUCCESSFUL_WIRE_PAYMENT: 6,
    MONRI_PAGE: 7,
    CONFIRM_TERMS: 8
};

export const stepStatus = {
    PROCESS: "process",
    FINISH: "finish",
    WAITING: "wait"
};
